export default  {"src":"/_next/static/image/public/images/icon_sm_invoice_dark.2340a3a032651f81ec330ef2f5c25e7b.svg","height":25,"width":18};